const SectionHeader = ({ text, gradientText, description = '' }) => (
  <>
    <div
      className={`text-2xl md:text-5xl font-extrabold text-center ${
        description ? 'mb-2' : 'md:mb-12 mb-8'
      } text-stroke-thin md:text-stroke-bold font-Montserrat`}
    >
      {text}{' '}
      <span className='bg-control bg-clip-text text-transparent'>
        {gradientText}
      </span>
    </div>
    {description && (
      <div className='text-center text-base md:text-lg md:mb-12 mb-8 text-gray-700'>
        {description}
      </div>
    )}
  </>
);

export default SectionHeader;
